import React from 'react';
import { Section } from './ui/Section';
import { Target, Zap, Users, TrendingUp } from 'lucide-react';
const reasons = [{
  icon: Target,
  title: 'Klarer Fokus auf Wirkung',
  description: 'Wir optimieren nicht um der Optimierung willen, sondern für messbaren Geschäftserfolg.'
}, {
  icon: Zap,
  title: 'Technologiegetrieben',
  description: 'Wir nutzen moderne Tools und KI, verlieren aber nie den Faktor Mensch aus den Augen.'
}, {
  icon: Users,
  title: 'Vertriebsverständnis + IT',
  description: 'Die seltene Kombination aus tiefem Vertriebswissen und technischer Umsetzungskompetenz.'
}, {
  icon: TrendingUp,
  title: 'Keine Buzzwords',
  description: 'Ehrliche Beratung auf Augenhöhe. Wir sprechen Klartext und liefern Ergebnisse.'
}];
export function WhyUs() {
  return <Section id="why-us" background="dark" data-id="element-139">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-140">
        <div data-id="element-141">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-142">
            Warum KZEV?
          </h2>
          <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-143">
            In einer Welt voller theoretischer Berater sind wir die Praktiker,
            die Technologie und Vertriebspsychologie wirksam verbinden.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-144">
            {reasons.map((reason, index) => <div key={index} className="flex flex-col" data-id="element-145">
                <div className="flex items-center gap-3 mb-3" data-id="element-146">
                  <reason.icon className="w-5 h-5 text-emerald-400" data-id="element-147" />
                  <h3 className="font-bold text-white" data-id="element-148">{reason.title}</h3>
                </div>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-149">
                  {reason.description}
                </p>
              </div>)}
          </div>
        </div>

        <div className="relative hidden lg:block" data-id="element-150">
          <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 to-transparent rounded-sm transform translate-x-4 translate-y-4" data-id="element-151"></div>
          <div className="bg-slate-800 p-8 rounded-sm border border-slate-700 relative z-10" data-id="element-152">
            <blockquote className="text-lg text-slate-300 italic mb-6" data-id="element-153">
              "Die Zusammenarbeit mit KZEV hat unseren Vertrieb nicht nur
              digitalisiert, sondern die gesamte Kultur verändert. Wir schließen
              heute schneller und besser ab."
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-154">
              <div className="w-10 h-10 bg-slate-600 rounded-full flex items-center justify-center font-bold text-white" data-id="element-155">
                M
              </div>
              <div data-id="element-156">
                <div className="font-bold text-white" data-id="element-157">Michael Weber</div>
                <div className="text-xs text-slate-400" data-id="element-158">
                  Geschäftsführer, TechSolutions GmbH
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}